import React from "react";
import CreatorDetails from "../../../pages/ChangeRequest/activities/creatorDetails";
import { ucFirst } from "../../../helpers/string_helper";
import { Action } from "../../../constants/Common";
import { Modules } from "../../../constants/Module";
import ArrowRightAltOutlinedIcon from "@mui/icons-material/ArrowRightAltOutlined";
import { DeliverableStatus, ProjectStatuses } from "../../../constants/Status";
import moment from "moment";
import { withTranslation } from "react-i18next";
function ProjectDeliverable({ item, t}) {
  return (
    <div>
      <div>
        <strong>
          {" "}
          {ucFirst(Modules.DELIVERABLE)} ({item?.payload?.deliverableName ? item?.payload?.deliverableName : item?.payload?.deliverable?.old?.name}){" "}
        </strong>
         {item.event === Action.CREATE ? t("was added to") : item.event === Action.UPDATE ? t("was updated for") : t("was deleted from")}{" "}
        <strong>
          {t('startup')} {ucFirst(item.project?.name)} (
          {item?.project?.uniqueProjectId})
        </strong>{" "}
        {t('by')}
        <CreatorDetails creator={item?.creator} date={item?.createdAt} />
      </div>
      {item?.event === Action?.UPDATE && (
        <div>
            {typeof item?.payload?.currentStatus === "object" &&
            item?.payload?.currentStatus?.old &&
            item?.payload?.currentStatus?.new && (
              <div className="mx-2">
                <div className="d-flex align-items-center change_status">
                  <strong> {t('Status')}: </strong>
                  <div className="d-flex align-items-center mx-2">
                    <span>{item?.payload?.currentStatus?.old}</span>
                  </div>
                  <span className="middleArrow mx-2">
                    <ArrowRightAltOutlinedIcon />
                  </span>
                  <div className="d-flex align-items-center">
                    <span className="mx-2">{item?.payload?.currentStatus?.new}</span>
                  </div>
                </div>
              </div>
            )}
          {typeof item?.payload?.name === 'object' &&
            item?.payload?.name?.old &&
            item?.payload?.name?.new && (
              <div className="mx-2">
                <div className="d-flex align-items-center change_status">
                  <strong> {t('Name')}: </strong>
                  <div className="d-flex align-items-center mx-2">
                    <span>{item?.payload?.name?.old}</span>
                  </div>
                  <span className="middleArrow mx-2">
                    <ArrowRightAltOutlinedIcon />
                  </span>
                  <div className="d-flex align-items-center">
                    <span className="mx-2">{item?.payload?.name?.new}</span>
                  </div>
                </div>
              </div>
            )}
          {item?.payload?.dealRoomReg && typeof item?.payload?.dealRoomReg === "object" && (
            <div className="mx-2">
              <div className="d-flex align-items-center change_status">
                <strong> {t('Dealroom Registeration')}: </strong>
                <div className="d-flex align-items-center mx-2">
                  <span>{item?.payload?.dealRoomReg?.old ?? "N/A"}</span>
                </div>
                <span className="middleArrow mx-2">
                  <ArrowRightAltOutlinedIcon />
                </span>
                <div className="d-flex align-items-center">
                  <span className="mx-2">
                    {item?.payload?.dealRoomReg?.new ?? "N/A"}
                  </span>
                </div>
              </div>
            </div>
          )}
          {item?.payload?.crnName && typeof item?.payload?.crnName === "object" && (
            <div className="mx-2">
              <div className="d-flex align-items-center change_status">
                <strong> {t('CR Name')}: </strong>
                <div className="d-flex align-items-center mx-2">
                  <span>{item?.payload?.crnName?.old ?? "N/A"}</span>
                </div>
                <span className="middleArrow mx-2">
                  <ArrowRightAltOutlinedIcon />
                </span>
                <div className="d-flex align-items-center">
                  <span className="mx-2">
                    {item?.payload?.crnName?.new ?? "N/A"}
                  </span>
                </div>
              </div>
            </div>
          )}
          {item?.payload?.bankName && typeof item?.payload?.bankName === "object" && (
            <div className="mx-2">
              <div className="d-flex align-items-center change_status">
                <strong> {t('Bank Name')}: </strong>
                <div className="d-flex align-items-center mx-2">
                  <span>{item?.payload?.bankName?.old ?? "N/A"}</span>
                </div>
                <span className="middleArrow mx-2">
                  <ArrowRightAltOutlinedIcon />
                </span>
                <div className="d-flex align-items-center">
                  <span className="mx-2">
                    {item?.payload?.bankName?.new ?? "N/A"}
                  </span>
                </div>
              </div>
            </div>
          )}
          {item?.payload?.iBanNumber && typeof item?.payload?.iBanNumber === "object" && (
            <div className="mx-2">
              <div className="d-flex align-items-center change_status">
                <strong> {t('IBAN Number')}: </strong>
                <div className="d-flex align-items-center mx-2">
                  <span>{item?.payload?.iBanNumber?.old ?? "N/A"}</span>
                </div>
                <span className="middleArrow mx-2">
                  <ArrowRightAltOutlinedIcon />
                </span>
                <div className="d-flex align-items-center">
                  <span className="mx-2">
                    {item?.payload?.iBanNumber?.new ?? "N/A"}
                  </span>
                </div>
              </div>
            </div>
          )}
          {item?.payload?.crnNumber && typeof item?.payload?.crnNumber === "object" && (
            <div className="mx-2">
              <div className="d-flex align-items-center change_status">
                <strong> {t('CR Number')}: </strong>
                <div className="d-flex align-items-center mx-2">
                  <span>{item?.payload?.crnNumber?.old ?? "N/A"}</span>
                </div>
                <span className="middleArrow mx-2">
                  <ArrowRightAltOutlinedIcon />
                </span>
                <div className="d-flex align-items-center">
                  <span className="mx-2">
                    {item?.payload?.crnNumber?.new ?? "N/A"}
                  </span>
                </div>
              </div>
            </div>
          )}
          {item?.payload?.businessModel && typeof item?.payload?.businessModel === "object" && (
            <div className="mx-2">
              <div className="d-flex align-items-center change_status">
                <strong> {t('Business Model')}: </strong>
                <div className="d-flex align-items-center mx-2">
                  <span>{item?.payload?.businessModel?.old ?? "N/A"}</span>
                </div>
                <span className="middleArrow mx-2">
                  <ArrowRightAltOutlinedIcon />
                </span>
                <div className="d-flex align-items-center">
                  <span className="mx-2">
                    {item?.payload?.businessModel?.new ?? "N/A"}
                  </span>
                </div>
              </div>
            </div>
          )}
          {item?.payload?.customerSegmentAnalysis && typeof item?.payload?.customerSegmentAnalysis === "object" && (
            <div className="mx-2">
              <div className="d-flex align-items-center change_status">
                <strong> {t('Customer Segment Analysis')}: </strong>
                <div className="d-flex align-items-center mx-2">
                  <span>{item?.payload?.customerSegmentAnalysis?.old ?? "N/A"}</span>
                </div>
                <span className="middleArrow mx-2">
                  <ArrowRightAltOutlinedIcon />
                </span>
                <div className="d-flex align-items-center">
                  <span className="mx-2">
                    {item?.payload?.customerSegmentAnalysis?.new ?? "N/A"}
                  </span>
                </div>
              </div>
            </div>
          )}
          {item?.payload?.valuePropositionModel && typeof item?.payload?.valuePropositionModel === "object" && (
            <div className="mx-2">
              <div className="d-flex align-items-center change_status">
                <strong> {t('Value Proposition Model')}: </strong>
                <div className="d-flex align-items-center mx-2">
                  <span>{item?.payload?.valuePropositionModel?.old ?? "N/A"}</span>
                </div>
                <span className="middleArrow mx-2">
                  <ArrowRightAltOutlinedIcon />
                </span>
                <div className="d-flex align-items-center">
                  <span className="mx-2">
                    {item?.payload?.valuePropositionModel?.new ?? "N/A"}
                  </span>
                </div>
              </div>
            </div>
          )}
          {item?.payload?.virtualCustomerPersonality && typeof item?.payload?.virtualCustomerPersonality === "object" && (
            <div className="mx-2">
              <div className="d-flex align-items-center change_status">
                <strong> {t('Virtual Customer Personality')}: </strong>
                <div className="d-flex align-items-center mx-2">
                  <span>{item?.payload?.virtualCustomerPersonality?.old ?? "N/A"}</span>
                </div>
                <span className="middleArrow mx-2">
                  <ArrowRightAltOutlinedIcon />
                </span>
                <div className="d-flex align-items-center">
                  <span className="mx-2">
                    {item?.payload?.virtualCustomerPersonality?.new ?? "N/A"}
                  </span>
                </div>
              </div>
            </div>
          )}
          {item?.payload?.exercisesVariousAssumption && typeof item?.payload?.exercisesVariousAssumption === "object" && (
            <div className="mx-2">
              <div className="d-flex align-items-center change_status">
                <strong> {t('Exercises Various Assumption')}: </strong>
                <div className="d-flex align-items-center mx-2">
                  <span>{item?.payload?.exercisesVariousAssumption?.old ?? "N/A"}</span>
                </div>
                <span className="middleArrow mx-2">
                  <ArrowRightAltOutlinedIcon />
                </span>
                <div className="d-flex align-items-center">
                  <span className="mx-2">
                    {item?.payload?.exercisesVariousAssumption?.new ?? "N/A"}
                  </span>
                </div>
              </div>
            </div>
          )}
          {item?.payload?.marketSize && typeof item?.payload?.marketSize === "object" && (
            <div className="mx-2">
              <div className="d-flex align-items-center change_status">
                <strong> {t('Market Size')}: </strong>
                <div className="d-flex align-items-center mx-2">
                  <span>{item?.payload?.marketSize?.old ?? "N/A"}</span>
                </div>
                <span className="middleArrow mx-2">
                  <ArrowRightAltOutlinedIcon />
                </span>
                <div className="d-flex align-items-center">
                  <span className="mx-2">
                    {item?.payload?.marketSize?.new ?? "N/A"}
                  </span>
                </div>
              </div>
            </div>
          )}
          {item?.payload?.description && typeof item?.payload?.description === "object" && item?.payload?.description.new !== '' && (
            <div className="mx-2">
              <div className="d-flex align-items-center change_status">
                <strong> {t('Description')}: </strong>
                <div className="d-flex align-items-center mx-2">
                  <span>{item?.payload?.description?.old ?? "N/A"}</span>
                </div>
                <span className="middleArrow mx-2">
                  <ArrowRightAltOutlinedIcon />
                </span>
                <div className="d-flex align-items-center">
                  <span className="mx-2">
                    {item?.payload?.description?.new ?? "N/A"}
                  </span>
                </div>
              </div>
            </div>
          )}
          {item?.payload?.mvpTesting && typeof item?.payload?.mvpTesting === "object" && (
            <div className="mx-2">
              <div className="d-flex align-items-center change_status">
                <strong> {t('Mvp Testing')}: </strong>
                <div className="d-flex align-items-center mx-2">
                  <span>{item?.payload?.mvpTesting?.old ?? 'N/A'}</span>
                </div>
                <span className="middleArrow mx-2">
                  <ArrowRightAltOutlinedIcon />
                </span>
                <div className="d-flex align-items-center">
                  <span className="mx-2">{item?.payload?.mvpTesting?.new ?? 'N/A'}</span>
                </div>
              </div>
            </div>
          )}
          {item?.payload?.startDate &&
            item?.payload?.startDate?.old &&
            item?.payload?.startDate?.new && (
              <div className="mx-2">
                <div className="d-flex align-items-center change_status">
                  <strong> {t('Start Date')}: </strong>
                  <div className="d-flex align-items-center mx-2">
                    <span>{moment(item?.payload?.startDate?.old).format("Do MMMM, YYYY")}</span>
                  </div>
                  <span className="middleArrow mx-2">
                    <ArrowRightAltOutlinedIcon />
                  </span>
                  <div className="d-flex align-items-center">
                    <span className="mx-2">
                    {moment(item?.payload?.startDate?.new).format("Do MMMM, YYYY")}
                    </span>
                  </div>
                </div>
              </div>
            )}
          {item?.payload?.endDate &&
            item?.payload?.endDate?.old &&
            item?.payload?.endDate?.new && (
              <div className="mx-2">
                <div className="d-flex align-items-center change_status">
                  <strong> {t('End Date')}: </strong>
                  <div className="d-flex align-items-center mx-2">
                    <span>{moment(item?.payload?.endDate?.old).format("Do MMMM, YYYY")}</span>
                  </div>
                  <span className="middleArrow mx-2">
                    <ArrowRightAltOutlinedIcon />
                  </span>
                  <div className="d-flex align-items-center">
                    <span className="mx-2">{moment(item?.payload?.endDate?.new).format("Do MMMM, YYYY")}</span>
                  </div>
                </div>
              </div>
            )}
        </div>
      )}
    </div>
  );
}
export default withTranslation()(ProjectDeliverable);